import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import Modal from "react-bootstrap/lib/Modal";
import TextField from "material-ui/TextField";
import axios from "axios";
import toastr from "toastr";

function dateFormat(cell) {
  if (cell != null && cell != 'NA' && cell != 0)
    return <font>{cell.toDateString()}</font>
  else
    return 'NA';
}

class NewJoinerTable extends React.Component {

  constructor() {
    super();
    this.state = {flag: {}, open: false, emailId: null, employee: {}, error: ""};
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  close() {
    this.setState({open: false});
  }

  open(row) {
    this.setState({open: true, employee: row});
  }

  componentDidMount() {
    let flag = new Object();
    console.log(this.props.data);
    this.props.data.map((node)=> {
      flag[node.id] = false;
    });
    this.setState({flag: flag})
  }

  componentWillReceiveProps(props) {

    let flag = new Object();
    console.log(props.data);
    props.data.map((node)=> {
      flag[node.id] = false;
    });
    this.setState({flag: flag})
  }

  render() {
    console.log(this.state.flag);
    return (
      <div>
        <BootstrapTable exportCSV={true} search={true} data={this.props.data}>
          <TableHeaderColumn hidden={true} isKey={true} dataField="id">Id</TableHeaderColumn>

          <TableHeaderColumn dataSort={true} dataField="empId">EmpId</TableHeaderColumn>
          <TableHeaderColumn dataSort={true} dataField="name">Name</TableHeaderColumn>
          <TableHeaderColumn dataField="location">Location</TableHeaderColumn>
          <TableHeaderColumn dataField="vertical">Vertical</TableHeaderColumn>
          <TableHeaderColumn dataField="emailIdProfessional">Email Id</TableHeaderColumn>
          <TableHeaderColumn dataField="payroll">Payroll</TableHeaderColumn>
          <TableHeaderColumn dataFormat={dateFormat} dataField="joiningDate">Date Of Joining</TableHeaderColumn>

        </BootstrapTable>

        <Modal
          bsSize="small"
          show={this.state.open} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>Assign Email Id</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Name: {this.state.employee.name}
            <br/>
            Domain: {this.state.employee.mailDomain}
            <br/>
            Assets: {this.state.employee.assets}
            <br/>
            <TextField name="emailId"
                       type="email"
                       defaultValue={this.state.employee.emailIdProfessional}
                       errorText={this.state.error}
                       onBlur={(event)=> {

                         if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value))
                           this.setState({emailId: event.target.value, error: ""})
                         else this.setState({error: "InvalidEmailId", emailId: event.target.value})
                       }}
                       hintText="Professional Email Id" floatingLabelText="Email Id"/>

            <button
              onClick={()=> {
                let requestObject = new Object();
                Object.assign(requestObject, this.state.employee);
                if (this.state.error == "") {

                  requestObject.email = this.state.emailId;
                  axios.post(process.env.REQ_URL + "/onBoarding/saveEmailId", {data: requestObject}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                    this.close();
                    this.props.refresh();
                    toastr.success("Data updated")

                  }).catch((err)=> {
                    toastr.error("Error Occurred");

                  });

                }
              }}
              className="btn btn-default btn-block">Save
            </button>
            &nbsp;
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

NewJoinerTable.propTypes = {};

export default NewJoinerTable;





/** WEBPACK FOOTER **
 ** ./src/feature/finance/OnBoarding/NewJoinerTable.js
 **/